var path = 'msi/modals/modal-window.html';
var html = "<div class=\"og-modal-dialog og-modal-size-{{ size || 'lg' }}\">\n  <div class=\"og-modal-content\" uib-modal-transclude></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;